// Simple in-memory holder for effective permissions snapshot hydrated from backend
import type { Permission } from './types';

let effectivePermissions: Permission[] = [];
let permissionVersion = '0';
let permissionChecksum = '';

export const setEffectivePermissions = (perms: Permission[], version: string, checksum: string) => {
  effectivePermissions = Array.isArray(perms) ? perms : [];
  permissionVersion = version || '0';
  permissionChecksum = checksum || '';
};

export const getEffectivePermissions = (): Permission[] => effectivePermissions;
export const getPermissionVersion = (): string => permissionVersion;
export const getPermissionChecksum = (): string => permissionChecksum;
